import './stats.less';
import React from 'react';

import ProtectedLayout from '../../common/protected-layout';
import {inject, observer} from 'mobx-react';
import {Loading} from '../../common/loading';
import {PhoneNumber} from '../../common/phone-number';

@inject("loginStore")
@inject("clientsStore")
@observer
export class ClientsStats extends React.Component {

  componentDidMount() {
    this.props.clientsStore.loadAll();
  }

  render() {
    const { isLoadingClients } = this.props.clientsStore;
    return (
      <ProtectedLayout
        loginStore={this.props.loginStore}
        right={''}
        onLogout={this.props.loginStore.logout}
        className="clients-stats">

        {isLoadingClients ? <Loading /> : this.renderContent()}
      </ProtectedLayout>
    );
  }

  renderContent() {
    const { ourClients } = this.props.clientsStore;

    const ecp = {};
    const creators = {};
    for(const client of ourClients || []) {
      const c = { ...client };
      if(!c.ecp) c.ecp = 'Не определено';
      if(!c.creatorName) c.creatorName = 'Не определено';

      const e = c.ecp.trim().toLowerCase().replace( /\s\s+/g, ' ' );
      const cr = c.creatorName.trim().toLowerCase().replace( /\s\s+/g, ' ' );
      if(!ecp[e]) {
        ecp[e] = { name: c.ecp, count: 0 };
      }
      if(!creators[cr]) {
        creators[cr] = { name: c.creatorName, count: 0 }
      }

      ecp[e].count++;
      creators[cr].count++;
    }

    const [phones, withoutPhones] = this.calculatePhoneStats();

    const ecpArr = Object.keys(ecp).map(i => ecp[i]).sort((a, b) => a.count > b.count ? 1 : -1);
    const creatorsArr = Object.keys(creators).map(i => creators[i]).sort((a, b) => a.count > b.count ? 1 : -1);

    return (
      <div className="stats-list">

        <div>
          <h2>Статистика по номерам</h2>

          <table>
            <thead>
            <tr>
              <th>Имя</th>
              <th>Номер</th>
              <th width="30px">Всего автомобилей</th>
              <th width="30px">Наши клиенты</th>
              <th width="30px">Потенциальные клиенты</th>
              <th width="30px">Архив</th>
            </tr>
            </thead>
            <tbody>
            <tr key={'without-phones'} style={{ backgroundColor: '#ffe'}}>
              <td></td>
              <td>Без номеров</td>
              <td>{withoutPhones.sum}</td>
              <td>{withoutPhones.our}</td>
              <td>{withoutPhones.req}</td>
              <td>{withoutPhones.arc}</td>
            </tr>
            {phones.map(i => (
              <tr key={i.phone}>
                <td>{i.name}</td>
                <td><PhoneNumber phone={i.phone}/></td>
                <td>{i.sum}</td>
                <td>{i.our}</td>
                <td>{i.req}</td>
                <td>{i.arc}</td>
              </tr>
            ))}
            </tbody>
          </table>
        </div>

        <div>
          <h2>Статистика по ЭЦП</h2>

          <table>
            <thead>
            <tr>
              <th>ЭЦП</th>
              <th>Количество автомобилей</th>
            </tr>
            </thead>
            <tbody>
            {ecpArr.map(i => (
              <tr key={i}>
                <td>{i.name}</td>
                <td width="30px">{i.count}</td>
              </tr>
            ))}
            </tbody>
          </table>
        </div>

        <div>
          <h2>Статистика по людям</h2>

          <table>
            <thead>
            <tr>
              <th>Кто делал</th>
              <th width="30px">Количество автомобилей</th>
            </tr>
            </thead>
            <tbody>
            {creatorsArr.map(i => (
              <tr key={i}>
                <td>{i.name}</td>
                <td>{i.count}</td>
              </tr>
            ))}
            </tbody>
          </table>
        </div>

      </div>
    );
  }

  calculatePhoneStats() {
    const { ourClients, reqClients, arcClients } = this.props.clientsStore;
    const phones = {};
    const clientTypes = { our: ourClients, req: reqClients, arc: arcClients };
    for (const type of Object.keys(clientTypes)) {
      const items = clientTypes[type] || [];
      for (const client of items) {
        const phone = this._hashPhone(client.phone);
        if (!phones[phone]) {
          phones[phone] = { our: 0, req: 0, arc: 0, name: client.name };
        }
        phones[phone][type]++;
      }
    }

    const sum = (v) => v.our + v.arc + v.req;

    const withoutPhones = phones['nope'] || { our: 0, req: 0, arc: 0 };
    withoutPhones.sum = sum(withoutPhones);

    delete phones['nope'];

    const phonesArr = Object.keys(phones)
      .map(phone => ({ phone, ...phones[phone], sum: sum(phones[phone]) }))
      .sort((a, b) => b.sum - a.sum);

    return [ phonesArr, withoutPhones ];
  }

  _hashPhone(phone) {
    if (!phone) {
      return 'nope';
    }
    phone = phone.trim();

    if (phone.length === 10) {
      return '8' + phone;
    }

    if(phone.startsWith('+7')) {
      phone = phone.slice(2);
    } else if (phone.length === 11) {
      phone = phone.slice(1);
    }

    return '8' + phone;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/clients/stats.js